import { CALL_STATE_LOCAL_STORAGE, CALL_UPDATE_ACTION, ICallAction, ICallState, } from './types';

const ls = localStorage.getItem(CALL_STATE_LOCAL_STORAGE);
const persistedState: ICallState = ls
	? JSON.parse(ls)
	: {
		multilingual: true,
	};
// saveLevel/startedAt are per-room, always re-fetched fresh — a value persisted from a past room must
// never leak into a new one before the create/join response lands.
const { saveLevel: _staleSaveLevel, startedAt: _staleStartedAt, ...initialState }: ICallState = persistedState;

const _callReducer = (
	state = initialState,
	action: ICallAction,
): ICallState => {

	switch (action.type) {
		case CALL_UPDATE_ACTION:
			return {
				...state,
				...action.call,
			};

		default:
			return state;
	}
};

export const callReducer = (
    state = initialState,
	action: ICallAction,
): ICallState => {
	const newState = _callReducer(state, action);
	// `notice` is transient UI state — don't persist it, or a stale one would show the "session
	// ended" card on the next fresh load. `saveLevel`/`startedAt` are per-room (see initialState above)
	// — never persist them either, or they leak into the next, unrelated room the same browser opens.
	const { notice, saveLevel, startedAt, ...persisted } = newState;
	localStorage.setItem(CALL_STATE_LOCAL_STORAGE, JSON.stringify(persisted));
	return newState;
};
